// Stimulus controller that enables navigation when an element is clicked.
// It redirects the browser to the URL specified in the element's `data-href` attribute.
//
// Usage:
// - Attach the controller to a parent element (e.g., a <table> or <div>).
// - Add `data-action="click->storefront--clickable-row#navigate"` to each clickable element.
// - Ensure each clickable element has a `data-href` attribute with the destination URL.
//
// Behavior:
// - When the element is clicked, the browser navigates to the specified `data-href`.
//

import { Controller } from "stimulus";

export default class extends Controller {
  navigate(event: Event): void {
    const target = event.currentTarget as HTMLElement;
    const href = target.dataset.href;

    if (href) {
      window.location.href = href;
    }
  }
}
